import { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  useV1MarketplaceListingsCreate,
  useV1MarketplaceCatalogRevisionsList,
  useV1MarketplaceStoreRevisionsList
} from "@/api/generated/v1/v1";
import { PageBanner } from "@/shared/components/PageBanner";

export function ListingCreatePage() {
  const navigate = useNavigate();
  const [catalogRevision, setCatalogRevision] = useState("");
  const [storeRevision, setStoreRevision] = useState("");
  const { mutate, isPending, error } = useV1MarketplaceListingsCreate();

  // @ts-ignore
  const { data: catalogsData, isLoading: isLoadingCatalogs } = useV1MarketplaceCatalogRevisionsList({ status: "published" });
  // @ts-ignore
  const { data: storesData, isLoading: isLoadingStores } = useV1MarketplaceStoreRevisionsList({ status: "published" });

  const catalogs = catalogsData?.results ?? [];
  const stores = storesData?.results ?? [];

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    mutate(
      {
        data: {
          catalog_revision: catalogRevision,
          store_revision: storeRevision,
        },
      },
      {
        onSuccess: (res: any) => {navigate(`/marketplace/listings/${res.data.id}`)},
      }
    );
  };

  return (
    <div style={{ padding: "0.5rem 0", maxWidth: "100%", margin: "0", display: "flex", flexDirection: "column", gap: "1.5rem" }}>
      <PageBanner
        title="آگهی جدید"
        subtitle="برای ایجاد آگهی، لطفاً کاتالوگ و فروشگاه مورد نظر را از لیست‌های منتشرشده انتخاب کنید."
        icon="📢"
        helpLink="/help/marketplace/listing-create"
      />

      <div className="brand-card-extand" style={{ padding: "1.5rem" }}>
        <form onSubmit={handleSubmit} style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
          <div>
            <label style={{ display: "block", marginBottom: "8px" }}>کاتالوگ (Catalog Revision)</label>
            <select
              className="input-field"
              value={catalogRevision}
              onChange={(e) => setCatalogRevision(e.target.value)}
              required
              style={{ width: "100%", padding: "12px" }}
            >
              <option value="">انتخاب کنید...</option>
              {catalogs.map((c: any) => (
                <option key={c.id} value={c.id}>
                  {c.title || c.id} (نسخه: {c.revision_no})
                </option>
              ))}
            </select>
            {isLoadingCatalogs && <small>در حال دریافت...</small>}
          </div>
          
          <div>
            <label style={{ display: "block", marginBottom: "8px" }}>فروشگاه (Store Revision)</label>
            <select
              className="input-field"
              value={storeRevision}
              onChange={(e) => setStoreRevision(e.target.value)}
              required
              style={{ width: "100%", padding: "12px" }}
            >
              <option value="">انتخاب کنید...</option>
              {stores.map((s: any) => (
                <option key={s.id} value={s.id}>
                  نسخه فروشگاه: {s.revision_no} ({s.id})
                </option>
              ))}
            </select>
            {isLoadingStores && <small>در حال دریافت...</small>}
          </div>

          {Boolean(error) && <p style={{ color: "red" }}>خطا در ایجاد آگهی.</p>}
          <button type="submit" disabled={isPending || isLoadingCatalogs || isLoadingStores} className="btn-primary" style={{ marginTop: "16px" }}>
            {isPending ? "در حال ایجاد..." : "ایجاد آگهی"}
          </button>
        </form>
      </div>
    </div>
  );
}
